module.exports = __webpack_public_path__ + "img/type20010.d59360b3.png";